import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import useWaitForCallbackExpectedFieldForm from "./useWaitForCallbackExpectedFieldForm";
import WaitForCallbackExpectedFieldForm from "./WaitForCallbackExpectedFieldForm";

export default WaitForCallbackExpectedFieldDialog;

function WaitForCallbackExpectedFieldDialog(props) {
  const {
    onClose,
    expectedFieldDialog,
    onAddExpectedField,
    onUpdateExpectedField,
  } = props;

  const { formState, updateFormState, errors, validate } =
    useWaitForCallbackExpectedFieldForm(expectedFieldDialog.expectedField);

  const isModeAdd = expectedFieldDialog.mode === "add";

  const title = isModeAdd ? "Add Field" : "Edit Field";
  const primaryCtaLabel = isModeAdd ? "Add" : "Save";

  const handlePrimary = () => {
    if (!validate()) return;

    isModeAdd
      ? onAddExpectedField(formState)
      : onUpdateExpectedField(formState, expectedFieldDialog.expectedFieldIdx);

    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        <WaitForCallbackExpectedFieldForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handlePrimary}>{primaryCtaLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}
